<div #ref>
  <ng-content select="[first]"></ng-content>
  <hr *ngIf="ref.children.length > 1 && showSeparator" />
  <ng-content select="[second]"></ng-content>
  <hr *ngIf="ref.children.length > 3 && showSeparator" />
  <ng-content select="[third]"></ng-content>
  <hr *ngIf="ref.children.length > 5 && showSeparator" />
  <ng-content select="[fourth]"></ng-content>
  <hr *ngIf="ref.children.length > 7 && showSeparator" />
  <ng-content select="[fifth]"></ng-content>
  <hr *ngIf="ref.children.length > 9 && showSeparator" />
  <ng-content select="[sixth]"></ng-content>
  <hr *ngIf="ref.children.length > 11 && showSeparator" />
  <ng-content select="[seventh]"></ng-content>
</div>
